class rolesDto{
    ADMIN = 'admin'
    USER = 'user'
    INFLUENCER = 'influencer'
    PROMOTOR = 'promotor'
}

export default new rolesDto()